import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadAdvertisement = createAction('[Advertisement Page] Init');

export const loadAdvertisementSuccess = createAction(
  '[Advertisement/API] Load adveAtisement Success',
  props<{ advertisement: CasualTournamentEntity[] }>(),
);

export const loadAdvertisementFailure = createAction(
  '[Advertisement/API] Load adveAtisement Failure',
  props<{ error: any }>(),
);
